import React from "react";
import PropTypes from "prop-types";

export default function SearchBox({
  searchRef,
  data,
  propertyToLookFor,
  changeHandler,
  placeholder,
  searchBoxStyles,
}) {
  const localChangeHandler = (event) => {
    let searchedText = event.target.value.toLowerCase();
    let filteredData = data;

    if (searchedText) {
      filteredData = data.filter((eachEntryInData) =>
        eachEntryInData[propertyToLookFor].toLowerCase().includes(searchedText)
      );
    }

    changeHandler(filteredData);
  };

  return (
    <div className={searchBoxStyles}>
      <input
        ref={searchRef}
        type="text"
        class="form-control form-control-sm inputBox inputFieldStyle mr-2"
        id="searchTarget"
        placeholder={placeholder || "Search"}
        onChange={localChangeHandler}
      />
    </div>
  );
}

SearchBox.propTypes = {
  data: PropTypes.object,
  changeHandler: PropTypes.func,
  placeholder: PropTypes.string,
  searchBoxStyles: PropTypes.string,
};
